import React from "react";
import Todo from "./components/todolist/Todo";

function App() {
  return (
    <div>
      <Todo />
    </div>
  );
}

export default App;
